/**
 * Aba "Condições de pagamento" de /financeiro/cadastros.
 *
 * M-FIN-8 (auditoria 2026-08-07): existiam DUAS telas editando a mesma
 * `CondicaoPagamento` com formulários incompatíveis. Esta aba tinha o
 * formulário antigo (nº de parcelas + prazo em dias corridos) e
 * /comercial/configuracoes tem o atual (parcelas por ÂNCORA do processo:
 * aprovação, início da produção, entrega, instalação).
 *
 * Não é cosmético: as âncoras são o que a Fase 4 usa para transformar a
 * condição em contas a receber de verdade (achado A8). Editar por aqui
 * gravava uma segunda definição da mesma condição, e as duas telas
 * mostravam coisas diferentes sobre o mesmo cadastro.
 *
 * Uma verdade só: esta aba agora RENDERIZA o mesmo editor, em vez de
 * manter uma cópia divergente. A entrada pelo menu do Financeiro continua
 * existindo — quem procura cadastro no Financeiro encontra.
 */
import React from "react";

import { useAuth } from "../../../context/AuthContext";
import FormasPagamentoSection from "../../Comercial/Configuracoes/FormasPagamento";

export default function CondicoesTab() {
  const { hasAllPermissions, isMaster } = useAuth();
  const podeEditar =
    isMaster || hasAllPermissions(["financeiro:configurar"]);

  // `unidadeId` não é mais escolhido aqui: o backend deriva a unidade do
  // usuário no create (D-6C). Antes as duas telas liam `GET /api/unidades`
  // e pegavam a PRIMEIRA da lista — com dois tenants, cadastro no lugar
  // errado.
  return <FormasPagamentoSection podeEditar={podeEditar} />;
}
